import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type VerifyContainerScanFragment = { __typename?: 'VerifyContainerScanDocument', barcode: string, itemId?: string | null, orderId?: string | null, quantity: number, scannedAt: Types.TDateISO, scannedBy: string };

export type VerifyContainerSummaryFragment = { __typename?: 'VerifyContainerDocument', id: string, containerId: string, label: string, drop: string, status: Types.VerifyContainerStatus, submittedBy: string, submittedAt: Types.TDateISO, orderAssociations: Array<{ __typename?: 'VerifyContainerOrderAssociationDocument', orderId: string, orderNumber?: string | null }>, scans: Array<{ __typename?: 'VerifyContainerScanDocument', barcode: string, itemId?: string | null, orderId?: string | null, quantity: number, scannedAt: Types.TDateISO, scannedBy: string }> };

export type GetVerifyContainersQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.VerifyContainerDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.VerifyContainerDocumentSortInput> | Types.VerifyContainerDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetVerifyContainersQuery = { __typename?: 'Query', verifyContainers?: { __typename?: 'VerifyContainersConnection', totalCount: number, nodes?: Array<{ __typename?: 'VerifyContainerDocument', id: string, containerId: string, label: string, drop: string, status: Types.VerifyContainerStatus, submittedBy: string, submittedAt: Types.TDateISO, orderAssociations: Array<{ __typename?: 'VerifyContainerOrderAssociationDocument', orderId: string, orderNumber?: string | null }>, scans: Array<{ __typename?: 'VerifyContainerScanDocument', barcode: string, itemId?: string | null, orderId?: string | null, quantity: number, scannedAt: Types.TDateISO, scannedBy: string }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetVerifyOrderNumbersQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.OrdersDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.OrdersDocumentSortInput> | Types.OrdersDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetVerifyOrderNumbersQuery = { __typename?: 'Query', orders?: { __typename?: 'OrdersConnection', totalCount: number, nodes?: Array<{ __typename?: 'OrdersDocument', orderId: string, orderNumber: string, effectiveNotes: Array<{ __typename?: 'EffectiveOrderNote', context: Types.NoteContext, source: Types.EffectiveNoteSource, text?: string | null }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetOrderVerificationComparisonQueryVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
}>;


export type GetOrderVerificationComparisonQuery = { __typename?: 'Query', orderVerificationComparison: { __typename?: 'OrderVerificationComparison', orderId: string, lines: Array<{ __typename?: 'OrderVerificationComparisonLine', itemId: string, orderLineNumber: number, orderedQuantity: number, scannedQuantity: number, variance: Types.VerifyLineVariance }>, unknownItems: Array<{ __typename?: 'VerifyComparisonUnknownItem', itemId?: string | null, scannedQuantity: number, barcodes: Array<string> }>, containers: Array<{ __typename?: 'VerifyComparisonContainer', containerId: string, label: string, status: Types.VerifyContainerStatus, scanCount: number, drop: string, firstScannedAt?: Types.TDateISO | null, scannedQuantity: number }> } };

export type GetVerifyOrderLineDetailsQueryVariables = Types.Exact<{
  where: Types.OrderLineItemDocumentFilterInput;
  order?: Types.InputMaybe<Array<Types.OrderLineItemDocumentSortInput> | Types.OrderLineItemDocumentSortInput>;
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetVerifyOrderLineDetailsQuery = { __typename?: 'Query', orderLineItems?: { __typename?: 'OrderLineItemsConnection', totalCount: number, nodes?: Array<{ __typename?: 'OrderLineItemDocument', lineNumber: number, itemId: string, name: string, sku: string, customerSku?: string | null, customerUpc?: string | null, note?: { __typename?: 'LineItemNoteDocument', noteText: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteDocument', context: Types.NoteContext, text: string }>, upgrades: Array<{ __typename?: 'OrderLineUpgradeDocument', lineItemUpgradeId: string, name: string, categoryLabel?: string | null }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetVerifyPickedOrdersQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.OrdersDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.OrdersDocumentSortInput> | Types.OrdersDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetVerifyPickedOrdersQuery = { __typename?: 'Query', orders?: { __typename?: 'OrdersConnection', totalCount: number, nodes?: Array<{ __typename?: 'OrdersDocument', orderId: string, orderNumber: string, orderStatus: Types.OrderStatus, customerName: string, poNumber: string, plannedShipDate?: Types.TDateISO | null, numberOfLines: number }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetVerifyOrderByNumberQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.OrdersDocumentFilterInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetVerifyOrderByNumberQuery = { __typename?: 'Query', orders?: { __typename?: 'OrdersConnection', totalCount: number, nodes?: Array<{ __typename?: 'OrdersDocument', orderId: string, orderNumber: string, orderStatus: Types.OrderStatus }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetVerifyOrderVerificationQueryVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
}>;


export type GetVerifyOrderVerificationQuery = { __typename?: 'Query', order?: { __typename?: 'OrderStateData', orderId: string, verification?: { __typename?: 'OrderVerificationDetail', state: Types.OrderVerificationState, recountReason?: string | null, containers: Array<{ __typename?: 'OrderVerificationContainer', containerId: string, status: Types.VerifyContainerStatus }> } | null } | null };

export const VerifyContainerScanFragmentDoc = new TypedDocumentString(`
    fragment VerifyContainerScan on VerifyContainerScanDocument {
  barcode
  itemId
  orderId
  quantity
  scannedAt
  scannedBy
}
    `, {"fragmentName":"VerifyContainerScan"});
export const VerifyContainerSummaryFragmentDoc = new TypedDocumentString(`
    fragment VerifyContainerSummary on VerifyContainerDocument {
  id
  containerId
  label
  drop
  status
  submittedBy
  submittedAt
  orderAssociations {
    orderId
    orderNumber
  }
  scans {
    ...VerifyContainerScan
  }
}
    fragment VerifyContainerScan on VerifyContainerScanDocument {
  barcode
  itemId
  orderId
  quantity
  scannedAt
  scannedBy
}`, {"fragmentName":"VerifyContainerSummary"});
export const GetVerifyContainersDocument = new TypedDocumentString(`
    query GetVerifyContainers($where: VerifyContainerDocumentFilterInput, $order: [VerifyContainerDocumentSortInput!], $first: Int, $after: String) {
  verifyContainers(where: $where, order: $order, first: $first, after: $after) {
    nodes {
      ...VerifyContainerSummary
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment VerifyContainerScan on VerifyContainerScanDocument {
  barcode
  itemId
  orderId
  quantity
  scannedAt
  scannedBy
}
fragment VerifyContainerSummary on VerifyContainerDocument {
  id
  containerId
  label
  drop
  status
  submittedBy
  submittedAt
  orderAssociations {
    orderId
    orderNumber
  }
  scans {
    ...VerifyContainerScan
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetVerifyOrderNumbersDocument = new TypedDocumentString(`
    query GetVerifyOrderNumbers($where: OrdersDocumentFilterInput, $order: [OrdersDocumentSortInput!], $first: Int, $after: String) {
  orders(where: $where, order: $order, first: $first, after: $after) {
    nodes {
      orderId
      orderNumber
      effectiveNotes {
        ...EffectiveOrderNote
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
fragment EffectiveOrderNote on EffectiveOrderNote {
  context
  source
  text
}`);
export const GetOrderVerificationComparisonDocument = new TypedDocumentString(`
    query GetOrderVerificationComparison($orderId: String!) {
  orderVerificationComparison(orderId: $orderId) {
    orderId
    lines {
      itemId
      orderLineNumber
      orderedQuantity
      scannedQuantity
      variance
    }
    unknownItems {
      itemId
      scannedQuantity
      barcodes
    }
    containers {
      containerId
      label
      status
      scanCount
      drop
      firstScannedAt
      scannedQuantity
    }
  }
}
    `);
export const GetVerifyOrderLineDetailsDocument = new TypedDocumentString(`
    query GetVerifyOrderLineDetails($where: OrderLineItemDocumentFilterInput!, $order: [OrderLineItemDocumentSortInput!], $first: Int!, $after: String) {
  orderLineItems(where: $where, order: $order, first: $first, after: $after) {
    nodes {
      lineNumber
      itemId
      name
      sku
      customerSku
      customerUpc
      note {
        noteText
      }
      notes {
        context
        text
      }
      upgrades {
        lineItemUpgradeId
        name
        categoryLabel
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetVerifyPickedOrdersDocument = new TypedDocumentString(`
    query GetVerifyPickedOrders($where: OrdersDocumentFilterInput, $order: [OrdersDocumentSortInput!], $first: Int, $after: String) {
  orders(where: $where, order: $order, first: $first, after: $after) {
    nodes {
      orderId
      orderNumber
      orderStatus
      customerName
      poNumber
      plannedShipDate
      numberOfLines
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetVerifyOrderByNumberDocument = new TypedDocumentString(`
    query GetVerifyOrderByNumber($where: OrdersDocumentFilterInput, $first: Int) {
  orders(where: $where, first: $first) {
    nodes {
      orderId
      orderNumber
      orderStatus
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetVerifyOrderVerificationDocument = new TypedDocumentString(`
    query GetVerifyOrderVerification($orderId: String!) {
  order(orderId: $orderId) {
    orderId
    verification {
      state
      recountReason
      containers {
        containerId
        status
      }
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetVerifyContainers: build.query<GetVerifyContainersQuery, GetVerifyContainersQueryVariables | void>({
      query: (variables) => ({ document: GetVerifyContainersDocument, variables })
    }),
    GetVerifyOrderNumbers: build.query<GetVerifyOrderNumbersQuery, GetVerifyOrderNumbersQueryVariables | void>({
      query: (variables) => ({ document: GetVerifyOrderNumbersDocument, variables })
    }),
    GetOrderVerificationComparison: build.query<GetOrderVerificationComparisonQuery, GetOrderVerificationComparisonQueryVariables>({
      query: (variables) => ({ document: GetOrderVerificationComparisonDocument, variables })
    }),
    GetVerifyOrderLineDetails: build.query<GetVerifyOrderLineDetailsQuery, GetVerifyOrderLineDetailsQueryVariables>({
      query: (variables) => ({ document: GetVerifyOrderLineDetailsDocument, variables })
    }),
    GetVerifyPickedOrders: build.query<GetVerifyPickedOrdersQuery, GetVerifyPickedOrdersQueryVariables | void>({
      query: (variables) => ({ document: GetVerifyPickedOrdersDocument, variables })
    }),
    GetVerifyOrderByNumber: build.query<GetVerifyOrderByNumberQuery, GetVerifyOrderByNumberQueryVariables | void>({
      query: (variables) => ({ document: GetVerifyOrderByNumberDocument, variables })
    }),
    GetVerifyOrderVerification: build.query<GetVerifyOrderVerificationQuery, GetVerifyOrderVerificationQueryVariables>({
      query: (variables) => ({ document: GetVerifyOrderVerificationDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetVerifyContainersQuery, useLazyGetVerifyContainersQuery, useGetVerifyOrderNumbersQuery, useLazyGetVerifyOrderNumbersQuery, useGetOrderVerificationComparisonQuery, useLazyGetOrderVerificationComparisonQuery, useGetVerifyOrderLineDetailsQuery, useLazyGetVerifyOrderLineDetailsQuery, useGetVerifyPickedOrdersQuery, useLazyGetVerifyPickedOrdersQuery, useGetVerifyOrderByNumberQuery, useLazyGetVerifyOrderByNumberQuery, useGetVerifyOrderVerificationQuery, useLazyGetVerifyOrderVerificationQuery } = injectedRtkApi;
